import RankWords from "./RankWords";
export default RankWords